import {isProductDesktopViewport, PRODUCT_COMPACT_MAX_WIDTH} from '../../viewport/viewport';

/** Minimum real customer photos required to show the Customer Photos section. */
export const CUSTOMER_PHOTOS_MIN_COUNT = 3;

/**
 * Desktop placement uses viewport width strictly greater than this value.
 * At exactly this width, placement is compact/mobile.
 */
export const CUSTOMER_PHOTOS_DESKTOP_MIN_WIDTH = PRODUCT_COMPACT_MAX_WIDTH;

export interface CustomerPhotosVisibilityInput {
    isPortal3: boolean;
    allowCustomerPhotos: boolean;
    showCafDocSizes: boolean;
    isCaf: boolean;
    ready: boolean;
    realImageCount: number;
}

export type CustomerPhotosPlacement = 'desktop' | 'mobile' | 'none';

/** Whether the Customer Photos section (heading + tagline + carousel) may render at all. */
export function shouldShowCustomerPhotos(input: CustomerPhotosVisibilityInput): boolean {
    return !input.isPortal3 && input.allowCustomerPhotos && !input.showCafDocSizes && !input.isCaf && input.ready && input.realImageCount >= CUSTOMER_PHOTOS_MIN_COUNT;
}

/**
 * Picks desktop vs mobile slot when the section is visible.
 * Never returns both; at exactly CUSTOMER_PHOTOS_DESKTOP_MIN_WIDTH uses mobile.
 */
export function getCustomerPhotosPlacement(visible: boolean, viewportWidth: number): CustomerPhotosPlacement {
    if (!visible) {
        return 'none';
    }
    return isProductDesktopViewport(viewportWidth) ? 'desktop' : 'mobile';
}

/** Accessible name for a customer-photo control: prefer alt, else one-based fallback. */
export function getCustomerPhotoAccessibleName(alt: string | null | undefined, oneBasedIndex: number): string {
    const trimmed = typeof alt === 'string' ? alt.trim() : '';
    if (trimmed.length > 0) {
        return trimmed;
    }
    return `Customer image ${oneBasedIndex}`;
}
